export const makeFilterString = (filtersSelected, filters, querystring) => {
  const filterKeys = Object.keys(filtersSelected);

  if (!filterKeys.length) return undefined;

  let path = filterKeys
    .reduce((acc, key) => {
      const filterSelected = filtersSelected[key];
      const filterDef = filters.find((f) => f.key === key);

      const { multikey, targetValue } = filterDef || {};

      if (multikey && filterSelected && filterSelected.eq) {
        acc.push(
          `${filtersSelected[key].eq}=${
            filterDef.operator
          }%3A${encodeURIComponent(targetValue)}`,
        );
        return acc;
      }
      Object.entries(filterSelected).forEach(([operator, val]) => {
        const baseKey = key.split('+')[0];
        if (!filterDef) return;
        // &with_data_point=4:gte:0
        if (filterDef.source === 'parcels_polygon') {
          val.forEach((v) => {
            acc.push(
              `parcels_polygon=${baseKey}%3A${operator}%3A${encodeURIComponent(v)}`,
            );
          });
        } else if (filterDef.source === 'transactions') {
          acc.push(
            `transactions=${baseKey}%3A${operator}%3A${encodeURIComponent(val)}`,
          );
        } else if (filterDef.type === 'DATA_STREAM_MULTISELECT') {
          val.forEach((v) => {
            acc.push(
              `with_data_point=${
                filterDef.dataFieldId
              }%3A${operator}%3A${encodeURIComponent(v)}`,
            );
          });
        } else if (filterDef.type === 'DATA_STREAM_MIN_MAX') {
          acc.push(
            `with_data_point=${
              filterDef.dataFieldId
            }%3A${operator}%3A${encodeURIComponent(val)}`,
          );
        } else if (filterDef.type === 'DATA_STREAM_DATE_RANGE') {
          acc.push(
            `with_data_point=${filterDef.dataFieldId}%3A${
              baseKey
            }%5B${operator}%5D%3A${encodeURIComponent(val)}`,
          );
        } else if (Array.isArray(val)) {
          val.forEach((v) => {
            acc.push(`${baseKey}=${operator}%3A${encodeURIComponent(`${filterDef.prepend || ''}${v}${filterDef.postpend || ''}`)}`);
          });
        } else if (typeof val === 'object') {
          const coords = val.features[0].geometry.coordinates[0];
          coords.forEach((latLng) => {
            acc.push(`${baseKey}%5B%5D=${operator}%3A${latLng.join(' ')}`);
          });
        } else if (val) {
          acc.push(`${baseKey}=${operator}%3A${encodeURIComponent(`${filterDef.prepend || ''}${val}${filterDef.postpend || ''}`)}`);
        }
      });
      return acc;
    }, [])
    .join('&');

  if (path.length && querystring) {
    path = `${path}&${querystring}`;
  }

  return path;
};
